import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/shadcn/lib/utils";

const badgeVariants = cva(
  "inline-flex w-fit items-center justify-center gap-2 rounded-full border px-2.5 py-1 whitespace-nowrap",
  {
    variants: {
      variant: {
        "primary": "border-primary/60 border-transparent bg-primary type-body-xs text-white",
        "white": "border-neutral-400 bg-white text-foreground",
        "secondary": "border-transparent bg-secondary type-body-xs text-secondary-foreground",
        "accent": "border-transparent bg-accent type-body-xs text-accent-foreground",
        "muted": "border-transparent bg-muted type-body-xs text-muted-foreground",
        "success": "border-success/40 bg-success/10 type-body-xs text-success",
        "warning": "border-warning/40 bg-warning/10 type-body-xs text-foreground",
        "error": "border-destructive/40 bg-destructive/10 type-body-xs text-destructive",
        "outline": "border-neutral-400 bg-transparent type-body-xs text-foreground",
        "outline-solid": "border-neutral-400 bg-transparent type-body-xs text-foreground",
        "success-solid": "border-transparent bg-success type-body-xs text-white",
        "progress-solid": "border-transparent bg-progress type-body-xs text-white",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <span className={cn(badgeVariants({ variant }), className)} ref={ref} {...props} />
  ),
);

Badge.displayName = "Badge";
